var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferEarnLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19956 10.4775C5.54084 10.6541 5.14629 11.3374 5.3228 11.9961L5.64371 13.1938C5.82022 13.8525 6.50358 14.2471 7.1623 14.0706L7.76114 13.9101L8.40297 16.3055L9.60065 15.9846L8.95882 13.5892L9.55765 13.4287L13.0332 14.423L11.1077 7.23692L8.59491 9.83572L6.19956 10.4775ZM13.5676 10.4288C13.3542 9.63234 12.8143 9.0068 12.1318 8.66338L13.2052 12.6696C13.6262 12.0369 13.781 11.2252 13.5676 10.4288Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.252 8.30273L14.752 6.80273M13.7021 9.1018L15.7512 8.55276M13.9531 10.0528L16.0022 10.6018",
    stroke: "white",
    strokeWidth: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0928 11.4414C14.4751 11.4414 13.1621 12.7544 13.1621 14.3721C13.1621 15.9899 14.4751 17.3029 16.0928 17.3029C17.7106 17.3029 19.0236 15.9899 19.0236 14.3721C19.0236 12.7544 17.7106 11.4414 16.0928 11.4414ZM16.3507 16.0602V16.4236H15.8379V16.0456C15.621 15.9928 15.1374 15.8199 14.9528 15.1781L15.4364 14.9817C15.4539 15.0462 15.6063 15.5943 16.1397 15.5943C16.4123 15.5943 16.72 15.4536 16.72 15.1224C16.72 14.8411 16.5149 14.6945 16.0518 14.5275C15.7294 14.4132 15.07 14.2256 15.07 13.5574C15.07 13.5281 15.0729 12.854 15.8379 12.6899V12.3206H16.3507V12.684C16.89 12.7778 17.0864 13.2086 17.1303 13.3376L16.6673 13.5339C16.635 13.4314 16.4943 13.1412 16.1104 13.1412C15.9053 13.1412 15.58 13.2497 15.58 13.5486C15.58 13.827 15.832 13.9325 16.3537 14.1054C17.057 14.3487 17.2358 14.7062 17.2358 15.1165C17.2358 15.8873 16.5031 16.0339 16.3507 16.0602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferEarnLogo);
export default __webpack_public_path__ + "static/media/refer-earn-logo.ce201b9cd45306bc045aecb05294b811.svg";
export { ForwardRef as ReactComponent };